import { render, staticRenderFns } from "./CheckListV2Form.vue?vue&type=template&id=509b22b6"
import script from "./CheckListV2Form.vue?vue&type=script&lang=js"
export * from "./CheckListV2Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports